export enum UserGender {
	MALE = "MALE",
	FEMALE = "FEMALE",
	OTHER = "OTHER",
}
